<div class="tix-event-content">
  <div class="tix-header-branding">
    <div class="tix-logo">
      <img
        onerror="this.src='https://asylumtixmedia.sfo3.digitaloceanspaces.com/asylumTix/default_images/ticket_logo.jpg'"
        [src]="!venueMedias ? companyMedias : venueMedias"
        alt=""
      />
    </div>
    <div class="tix-address">
      <h1>{{ venueDetail?.name }}</h1>
      <h6>{{ formattedVenueAddress() }}</h6>
    </div>
  </div>
  <div class="tix-event-content-detail">
    <quill-view-html
      [content]="venueDetail?.additionalInfo ?? ''"
    ></quill-view-html>
  </div>
  <div class="event-video" *ngIf="id">
    <iframe [src]="safeURL" height="235" width="427" allowfullscreen></iframe>
  </div>
  <div class="location-ticket-header ticket-header">
    <h3 class="ticket-header-title">Event Location</h3>
    <h6>
      <tix-icon svgIcon="map-icon-solid"></tix-icon>{{ venueDetail?.name }}
      {{ formattedVenueAddress() }}
    </h6>
  </div>
  <div class="location-map" *ngIf="formattedVenueAddress()">
    <tix-venue-map
      *ngIf="formattedVenueAddress()"
      [formattedAddress]="formattedVenueAddress()"
    ></tix-venue-map>
  </div>
</div>
<div class="md:mt-8 mt-3 hidden sm:block" *ngIf="phoneNumbers.length">
  <h3 class="text-base font-medium mb-1">Want to call us?</h3>

  <div class="text-gray-900 text-sm" *ngFor="let phoneNumber of phoneNumbers">
    <strong>{{ phoneNumber.type }}: </strong
    ><a [href]="getPhoneNumberHref(phoneNumber.phoneNumber)">
      <span class="!text-gray-900 underline sm:no-underline">
        {{ formatPhoneNumber(phoneNumber.phoneNumber) }}
      </span>
    </a>
  </div>
</div>

<div class="tix-company-content mt-2 md:mt-5 mb-5">
  <!-- tix company warnings -->
  <div class="tix-company-warning" *ngIf="warningsLength > 0">
    <h3 class="text-sm font-medium mb-3">Company Message</h3>
    <tix-alert
      *ngFor="let warn of venueDetail?.company?.warnings"
      [alertType]="warn?.warning?.type === 'Important' ? 'warn' : 'info'"
      [alertMessage]="warn?.warning?.message ?? 'there is no available message'"
    ></tix-alert>
  </div>
</div>
